export default {
  name: {
    id: 'rm_metal_tungsten_name',
    defaultMessage: 'Tungsten',
  },
  smartphoneLabel: {
    id: 'rm_metal_tungsten_smartphone_label',
    defaultMessage: 'Significant',
  },
  whatItDoesText: {
    id: 'rm_metal_tungsten_what_it_does',
    defaultMessage:
      'Tungsten fills microscopic vertical connections between chip layers, linking transistors across multiple levels. Its electrical conductivity and near-zero vapour pressure at extreme temperatures make it uniquely reliable for this role. In vibration motors, its exceptional density makes it an ideal counterweight, creating the physical feedback you feel when your phone buzzes.',
  },
  extractionText1: {
    id: 'rm_metal_tungsten_extraction_p1',
    defaultMessage:
      'Tungsten is extracted mainly from two ores, scheelite and wolframite. Once the ore has been extracted and crushed, scheelite is separated by flotation, while wolframite is concentrated through magnetic separation. The concentrate is then purified into ammonium paratungstate (APT), the key intermediate form in which tungsten is traded globally. APT is converted into tungsten oxide and tungsten powder before being pressed at high temperature into bars and rods. Most primary processing takes place near the mines, overwhelmingly in China.',
  },
  quickFactText: {
    id: 'rm_metal_tungsten_quick_fact',
    defaultMessage:
      'Every buzz of your phone runs on a conflict mineral controlled 83% by China, whose reserves run out by 2042.',
  },
  envSummaryText: {
    id: 'rm_metal_tungsten_env_summary',
    defaultMessage:
      'Tungsten is extracted from two ores called scheelite and wolframite, both of which require energy-intensive crushing and chemical processing. A key step is the production of ammonium paratungstate (ATP), which requires large volumes of alkaline chemicals. Because mining and processing are highly concentrated in China, environmental oversight varies greatly from site to site.',
  },
  humanSummaryText: {
    id: 'rm_metal_tungsten_human_summary',
    defaultMessage:
      'Tungsten is one of the four minerals covered by the European Union’s Conflict Minerals Regulation, alongside gold, tin and tantalum. Its extraction in conflict zones can finance violence or involve forced labour, including child labour in dangerous conditions. Research indicates that women living near artisanal mining sites in eastern Congo face a significantly higher risk of sexual violence. Smuggling makes these supply chains almost impossible to trace.',
  },
  humanHealthText: {
    id: 'rm_metal_tungsten_human_health_text',
    defaultMessage:
      'Working in artisanal mines exposes workers to dust, toxic substances and the risk of mine collapse. In small-scale mines in conflict-affected regions where tungsten is extracted, safety standards are often far below those of large industrial operations. Respiratory diseases and skin conditions caused by hazardous materials are among the most common reported consequences. Workers in these areas also face attacks and physical abuse from groups controlling the surrounding territory.',
  },
  humanChildLabourText: {
    id: 'rm_metal_tungsten_human_child_labour_text',
    defaultMessage:
      'The European Union’s Conflict Minerals Regulation, which explicitly covers tungsten, recognises child labour as one of the human-rights violations common in conflict-affected mining regions. Children work in toxic and dangerous environments without adequate safety measures and often lack access to basic rights such as healthcare and education. In the most extreme cases, they face forced labour in mines or physical violence from groups controlling the surrounding territory.',
  },
  humanGenderText: {
    id: 'rm_metal_tungsten_human_gender_text',
    defaultMessage:
      'Research in eastern Congo shows that women living near artisanal mining sites are significantly more likely to experience sexual violence from partners or strangers. In the Kivu provinces, women living near mines controlled by armed groups face almost three times the risk of sexual violence compared with those living farther away. The European Union’s Conflict Minerals Regulation explicitly covers tungsten and was created in part to reduce the revenues that allow these groups to operate.',
  },
  geoSummaryText: {
    id: 'rm_metal_tungsten_geo_summary',
    defaultMessage:
      'China produces 83% of the world’s tungsten and dominates downstream processing. In 2024, production cuts and stricter environmental rules disrupted supply and pushed up tungsten prices. Regional conflicts and strong demand from solar, EV and other industries tightened the market further. Tungsten is one of the metals in which China holds a near-monopoly, highlighting the vulnerability of the global supply chain.',
  },
  geoDugText: {
    id: 'rm_metal_tungsten_geo_dug_text',
    defaultMessage:
      'Mining is heavily concentrated in China, which produces approximately 83% of the world’s tungsten. Vietnam (about 4.2%), Russia (about 2.5%) and Bolivia (about 2.0%) are the only other significant producers.',
  },
  geoProcessedText: {
    id: 'rm_metal_tungsten_geo_processed_text',
    defaultMessage:
      'Processing is similarly concentrated. Primary production, from concentrate to tungsten powder, takes place overwhelmingly near Chinese mines. More broadly, China is the dominant refiner for 19 of the 20 energy-related strategic minerals tracked by the IEA.',
  },
  geoLeverageText: {
    id: 'rm_metal_tungsten_geo_leverage_text',
    defaultMessage:
      'In February 2025, China imposed export-licensing requirements on tungsten and tungsten compounds, materials on which the global cutting-tool and electronics industries depend.',
  },
  supplySummaryText: {
    id: 'rm_metal_tungsten_supply_summary',
    defaultMessage:
      'Tungsten-carbide tools make it possible to mine lithium, cobalt, copper and rare earths. Without tungsten, the mining industry as we know it would grind to a halt. Despite China’s February 2025 export controls, tungsten prices did not rise sharply. By contrast, bismuth, another material covered by the same restrictions, rose by nearly 90%. Tungsten is identified as a political rather than a market risk because the threat is not yet reflected in prices.',
  },
  supplyReservesText: {
    id: 'rm_metal_tungsten_supply_reserves_text',
    defaultMessage:
      'GreenIT estimates that current tungsten reserves would last until around 2042 at current production rates. This is a static estimate, not a depletion forecast.',
  },
  supplyDemandText: {
    id: 'rm_metal_tungsten_supply_demand_text',
    defaultMessage:
      'Tungsten consumption in digital equipment in France is projected to increase by 12% between 2020 and 2030, and by 194% by 2050. This growth is driven mainly by the rollout of 5G base stations, which require significantly more tungsten than traditional consumer devices such as smartphones and tablets, whose tungsten content is expected to remain relatively stable.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_tungsten_recycling_summary',
    defaultMessage:
      'Around 42% of the tungsten used in the EU comes from recycled material, almost all of it recovered from cemented-carbide cutting tools through industrial take-back schemes. Smartphones present a very different picture: recycling operators do not consider tungsten recovery a priority. Only one initiative has been identified worldwide, Apple’s, and no industrial-scale recycling of tungsten from digital devices exists anywhere in Europe.',
  },
  recyclingInputText: {
    id: 'rm_metal_tungsten_recycling_input_text',
    defaultMessage:
      'Two entirely different worlds, one metal. Around 42% of the tungsten used in the EU comes from recycled industrial cutting tools. From smartphone vibration motors, the figure is effectively zero. The same metal that achieves one of the highest recycling rates in industry disappears from the recycling stream once it enters a consumer device.',
  },
  mine0Region: {
    id: 'rm_metal_tungsten_mine0_region',
    defaultMessage: 'Ganzhou',
  },
  mine1Region: {
    id: 'rm_metal_tungsten_mine1_region',
    defaultMessage: 'Núi Pháo',
  },
  mine2Region: {
    id: 'rm_metal_tungsten_mine2_region',
    defaultMessage: 'Cantung',
  },
  mine3Region: {
    id: 'rm_metal_tungsten_mine3_region',
    defaultMessage: 'Panasqueira',
  },
  mine4Region: {
    id: 'rm_metal_tungsten_mine4_region',
    defaultMessage: 'Mittersill',
  },
} as const
